import React from 'react';
import { ArrowRightIcon, FlameIcon } from 'lucide-react';
export function UrgencyBanner() {
  return <a href="#precios" aria-label="Ver la oferta del MEGAPACK" className="group block w-full bg-brand-orange text-white" data-id="element-348" data-mp="2iisg632m52da">
      <span className="mx-auto flex max-w-4xl items-center justify-center gap-2 px-4 py-2.5 text-center text-xs font-bold leading-tight sm:text-sm" data-id="element-349" data-mp="2nhdd9tmkj5xi">
        <FlameIcon className="h-4 w-4 shrink-0 fill-orange-100" aria-hidden="true" data-id="element-350" data-mp="2wbrtpziu4mi7" />
        <span data-id="element-351" data-mp="3191ta7zxuejr">
          <span className="text-orange-100" data-id="element-352" data-mp="318i88iezra1i">PRECIO DE LANZAMIENTO</span> — Esta
          semana el MEGAPACK está a $390 UYU. Después sube a $590.
        </span>
        <span className="hidden items-center gap-1 rounded-full border border-white/25 bg-white/10 px-3 py-1 sm:inline-flex" data-id="element-353" data-mp="3b8so6aseuvkd">
          Ver MEGAPACK <ArrowRightIcon className="h-3.5 w-3.5" data-id="element-354" data-mp="1bwpuk7q2oksz" />
        </span>
      </span>
    </a>;
}